(function ($, Global) {
    var MenuFeuilletonsComponent = function () {
        this.menuSelector = '.menu-feuilletons'
        this.btnSelector = '.btn-feuilleton';
        this.$btn = $(this.btnSelector);
        this.$el = $(this.menuSelector);
    };

    MenuFeuilletonsComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    };

    MenuFeuilletonsComponent.prototype.publishers = function () {
        var self = this;

        $(document).on('mouseover', this.btnSelector, function () {
            $('header .dropdown-toggle').each(function () {
                $(this).dropdown('hide')
            });
            $.Topic('show-menu-feuilletons').publish();
        });
        $(document).on('mouseleave', this.btnSelector, function () {
            $.Topic('hide-menu-feuilletons').publish();
        });
    };

    MenuFeuilletonsComponent.prototype.subscribers = function () {
        var self = this;
        $.Topic('show-menu-feuilletons').subscribe(function () {
            self.$btn.find('.dropdown-toggle').dropdown('show');
        });
        $.Topic('hide-menu-feuilletons').subscribe(function () {
            self.$btn.find('.dropdown-toggle').dropdown("hide");
        });
    };

    Global.MenuFeuilletonsComponent = MenuFeuilletonsComponent;
}(jQuery, window));